import { useContext } from "react";
import constants from "../constants";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import { getDataFromStorage } from "../util";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import CreateSchemaTableHooks from "./CreateSchemaTableHooks";
import { streamToUint8Array } from "../Components/CommonComponents/PdfViewer";
import useS3FileManagement from "./useS3FileManagement";
import * as axiosPublic from "../api/axios";

export default function McqAndDescHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { parseCreateTable } = CreateSchemaTableHooks();
  const {getPreSignedUrl,getS3Object} = useS3FileManagement()

  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();

  let tempReport,
    tempTq = 0,
    tempQa = 0,
    tempNa = 0,
    tempCa = 0,
    tempWa = 0,
    totalTS = 0,
    totalSS = 0,
    totalLS = 0,
    tempTestData,
    answerObject = {},
    tempScoresObj = {};

  const traverseInitialize = () => {
    Alert.setPrevButton(false);
    Alert.setNextButton(false);

    if (Alert.queLen > 1 || Alert.secLen > 1) {
      Alert.setNextButton(true);
    }
  };

  const questionUpdate = (secIndex, quesIndex, theObject) => {
    Alert.setSecLen(theObject.sections.length);
    Alert.setSecInd(secIndex);
    Alert.setSecObj(theObject.sections[secIndex]);
    Alert.setQueLen(theObject.sections[secIndex].questions.length);
    Alert.setQueInd(quesIndex);
    Alert.setQueObj(theObject.sections[secIndex].questions[quesIndex]);
    Alert.setOptObj(theObject.sections[secIndex].questions[quesIndex]?.options);

    if (
      Alert.comingObj.sections?.length === 1 &&
      Alert.comingObj.sections[0].questions.length === 1
    ) {
      Alert.setPrevButton(false);
      Alert.setNextButton(false);
    } else {
      if (secIndex === 0 && quesIndex === 0) {
        Alert.setPrevButton(false);
        Alert.setNextButton(true);
      } else if (
        secIndex === Alert.mcqTestData.sections.length - 1 &&
        quesIndex ===
          Alert.mcqTestData.sections[Alert.mcqTestData.sections.length - 1]
            .questions.length -
            1
      ) {
        Alert.setPrevButton(true);
        Alert.setNextButton(false);
      } else {
        Alert.setNextButton(true);
        Alert.setPrevButton(true);

        return;
      }
    }
  };

  const calcStats = (tempReport, sec) => {
    let actSec = 0;
    let secArr = [];
    let allQIids = [];
    let evalIds = [];
    let idScore = {};
    let allSec = false;
    let notEvalIds = [];

    for (let i = 0; i < tempReport.sections.length; i++) {
      secArr.push(i);
    }

    if (sec[0] === "all") {
      allSec = true;
      sec = secArr;
      actSec = sec.length;
    }

    for (let i = 0; i < tempReport.sections.length; i++) {
      if (sec.includes(i)) {
        for (let j = 0; j < tempReport.sections[i].questions.length; j++) {
          let questOnJ = tempReport.sections[i].questions[j];
          let score = questOnJ.actualscore;

          tempScoresObj = {
            ...tempScoresObj,
            [tempReport.sections[i].questions[j].id]: score,
          };

          tempTq++;
          allQIids.push(tempReport.sections[i].questions[j].id);

          if (
            tempReport.sections[i].questions[j].actualscore == null ||
            tempReport.sections[i].questions[j].hasOwnProperty(
              "actualscore"
            ) === false
          ) {
            notEvalIds.push(tempReport.sections[i].questions[j].id);
          } else if (tempReport.sections[i].questions[j].actualscore != null) {
            evalIds.push(tempReport.sections[i].questions[j].id);
            idScore = {
              ...idScore,
              [tempReport.sections[i].questions[j].id]:
                tempReport.sections[i].questions[j].actualscore,
            };
          }

          if (allSec) {
            totalTS = totalTS + tempReport.sections[i].questions[j].targetscore;
          }

          totalSS = totalSS + tempReport.sections[i].questions[j].targetscore;
          totalLS = totalLS + tempReport.sections[i].questions[j].actualscore;

          if (
            tempReport.sections[i].questions[j].answer === "" ||
            tempReport.sections[i].questions[j].answer == null
          ) {
            tempNa++;
          } else {
            tempQa++;
          }

          if (
            tempReport.sections[i].questions[j].targetscore ===
            tempReport.sections[i].questions[j].actualscore
          ) {
            tempCa++;
          } else {
            tempWa++;
          }
        }
      }
    }

    Alert.setTestStats({
      tq: tempTq,
      qa: tempQa,
      na: tempNa,
      ca: tempCa,
      wa: tempWa,
    });

    if (allSec) {
      Alert.setTotalTestScore(totalTS);
    }

    Alert.setFilterQuestionCount(tempTq);
    Alert.setTotalSecScore(totalSS);
    Alert.setTotalLearnerScore(totalLS);

    if (
      (sec[0] === "all" && sec.length > 1) ||
      actSec === 1 ||
      Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED
    ) {
      Alert.setAnsStats({
        allids: allQIids,
        evalids: evalIds,
        idscore: idScore,
        notevalids: notEvalIds,
      });
    }
  };

  const assignQuestionIds = (dataArr, sections1) => {
    return dataArr.map((section) => {
      const currentSection = {
        secId: section.secId,
        secName: section.secName,
        qnsObj: { ...section.qnsObj },
      };

      const relevantSection = sections1.find(
        (s) => s.sectionid === section.secId
      );
      if (relevantSection) {
        Object.keys(currentSection.qnsObj).forEach((key, index) => {
          const obj = currentSection.qnsObj[key];
          const matchedQuestion = relevantSection.questions[index];

          if (matchedQuestion) {
            obj.qId = matchedQuestion.id;
          }
        });
      }

      return currentSection;
    });
  };

  const handleVideoQuestions = (dataOfSections) => {
    let mArr = [];
    let questionList = dataOfSections.map((item, ind) => {
      let cc = 1;
      let MqObj = {
        qnsObj: {},
        secId: item.sectionid,
        secName: item.sectionname,
      };

      item.qnconfig.map((i) => {
        for (let j = 0; j < i.qncount + i.fixedqncount; j++) {
          let qObj = {};

          qObj.qId = "";
          qObj.marks = i.marks;
          qObj.isAnswered = false;
          MqObj.qnsObj[cc] = qObj;
          qObj.topicId = i.topicid;
          qObj.complexityId = i.complexityid;
          qObj.qnduration = i.qnduration / (i.qncount + i.fixedqncount);
          cc++;
        }

        return "";
      });

      mArr.push(MqObj);

      return "";
    });

    let videoQuestionsObj = assignQuestionIds(mArr, dataOfSections);

    Alert.questionListObj.current = videoQuestionsObj;
    Alert.sectionWithQuestions.current = dataOfSections;
  };

  const startTest = () => {
    Alert.setLpConfigId(Alert.testData.lpconfigid);

    Alert.setMcqAndDesTestAndLpId({
      lpid: Alert.lpId,
      status: Alert.status,
      testid: Alert.testData.testid,
      cellobj: Alert.testData.libtype,
      autoEval: Alert.testData.autoeval,
      testmode: Alert.testData.testmode,
      viewTest: Alert.testData.viewTest,
      libtypeid: Alert.testData.testtype,
      proctored: Alert.testData.proctored,
      configdata: Alert.testData.configdata,
      lpconfigid: Alert.testData.lpconfigid,
      learnerid: getDataFromStorage("learnerid"),
    });

    Alert.setTestPageShow(true);
    Alert.setTakeMcqAndDesTest(true);

    if (
      Alert.status === constants.PROGRESS_STATUS.UNLOCKED ||
      Alert.status === constants.PROGRESS_STATUS.REATTEMPT ||
      Alert.status === constants.PROGRESS_STATUS.REATTEMPT_NEW_VERSION
    ) {
      Alert.setIsLoaded(true);
      Alert.setButtonDisable(true);

      axios
        .post(
          "node/learner/course/test/get",
          JSON.stringify({
            lpid: Alert.lpId,
            isTakingTest: true,
            testid: Alert.testData.testid,
            mockuse: Alert.testData.mockuse,
            libtypeid: Alert.testData.testtype,
            lpconfigid: Alert.testData.lpconfigid,
            mocklp: localStorage.getItem("mockLp"),
            learnerid: getDataFromStorage("learnerid"),
          }),
          getHeaderDetailsForAxios()
        )
        .then((res) => {
          (async () => {
            try {
              Alert.setResultCode(res.data.resultCode);

              if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
                Alert.setShowNotify({
                  show: true,
                  title: "Info",
                  msg: res.data.msg,
                });
              } else {
                tempTestData = res.data.data;

                if (tempTestData.videoqn === 1) {
                  handleVideoQuestions(tempTestData.sections);
                }

                for (let i = 0; i < tempTestData.sections.length; i++) {
                  for (
                    let j = 0;
                    j < tempTestData.sections[i].questions.length;
                    j++
                  ) {
                    if (
                      Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
                    ) {
                      if (
                        tempTestData.sections[i].questions[j].answer === "" ||
                        tempTestData.sections[i].questions[j].answer === null ||
                        tempTestData.sections[i].questions[j].answer ===
                          undefined
                      ) {
                        tempTestData.sections[i].questions[j].choosed = -1;
                        tempTestData.sections[i].questions[j].answered = -1;
                        tempTestData.sections[i].questions[j].visited =
                          i === 0 && j === 0 ? "this" : "new";
                        tempTestData.sections[i].questions[j].review = -1;
                        tempTestData.sections[i].questions[j].previsited =
                          i === 0 && j === 0 ? "this" : "new";
                      } else {
                        tempTestData.sections[i].questions[j].visited =
                          "completed";
                        tempTestData.sections[i].questions[j].previsited =
                          "completed";
                        tempTestData.sections[i].questions[j].answered = 0;
                      }

                      answerObject = {
                        ...answerObject,
                        [tempTestData.sections[i].questions[j].id]:
                          tempTestData.sections[i].questions[j].answer,
                      };
                    } else {
                      tempTestData.sections[i].questions[j].choosed = -1;
                      tempTestData.sections[i].questions[j].answered = -1;
                      tempTestData.sections[i].questions[j].visited =
                        i === 0 && j === 0 ? "this" : "new";
                      tempTestData.sections[i].questions[j].review = -1;
                      tempTestData.sections[i].questions[j].previsited =
                        i === 0 && j === 0 ? "this" : "new";

                      answerObject = {
                        ...answerObject,
                        [tempTestData.sections[i].questions[j].id]: "",
                      };
                    }

                    if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
                      let question = tempTestData.sections[i].questions[j];

                      for (let k = 0; k < question.links.length; k++) {
                        let linkRes = await getPreSignedUrl(
                          question.links[k].link, undefined, question.links[k].link?.split(".")?.pop(), "GET"
                        );

                        question.links[k].link = linkRes.url;
                      }
                    }
                  }
                }

                Alert.setAnswers(answerObject);
                Alert.setMcqTestData(tempTestData);
                Alert.updateComingObj(tempTestData);
                questionUpdate(0, 0, tempTestData);
                Alert.updateQuestionContainerSingle(true);
                traverseInitialize();
                Alert.setTestMode(res.data.data.testmode);
                Alert.duration.current = tempTestData.duration;

                if (
                  (Alert.testData.proctored ===
                    constants.PROCTORING_MODE.TAB_CAM ||
                    Alert.testData.proctored === constants.PROCTORING_MODE.TAB_CAM_LOC) &&
                  Alert.testData.testmode === constants.MODE.TEST_MODE
                ) {
                  Alert.setIsTakeTest(true);
                }

                Alert.navigate("/mcq");
              }
            } catch (err) {
              getCatchBlockDetails(err);
            } finally {
              Alert.setIsLoaded(false);
              Alert.setButtonDisable(false);
            }
          })();
        })
        .catch((error) => {
          getCatchBlockDetails(error);
        })
        .finally(() => {
          Alert.setIsLoaded(false);
          Alert.setButtonDisable(false);
        });
    }

    if (Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE) {
      Alert.hasRendered.current = true;
      Alert.setIsLoaded(true);
      Alert.setButtonDisable(true);
      axios
        .post(
          "node/learner/course/test/report",
          JSON.stringify({
            lpid: Alert.lpId,
            isTakingTest: true,
            lmpid: Alert.testData.lmpid,
            testid: Alert.testData.testid,
            mockuse: Alert.testData.mockuse,
            libtypeid: Alert.testData.testtype,
            lpconfigid: Alert.testData.lpconfigid,
            mocklp: localStorage.getItem("mockLp"),
            learnerid: getDataFromStorage("learnerid"),
          }),
          getHeaderDetailsForAxios()
        )
        .then((res) => {
          Alert.hasRendered.current = false;
          Alert.backupTestDataq.current = res.data.data;

          (async () => {
            try {
              if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
                Alert.setShowNotify({
                  show: true,
                  title: "Info",
                  msg: res.data.message,
                });
              } else {
                tempTestData = res.data.data;

                if (tempTestData.videoqn === 1) {
                  handleVideoQuestions(tempTestData.sections);
                }

                for (let i = 0; i < tempTestData.sections.length; i++) {
                  for (
                    let j = 0;
                    j < tempTestData.sections[i].questions.length;
                    j++
                  ) {
                    if (
                      Alert.status === constants.PROGRESS_STATUS.QN_CONTINUE
                    ) {
                      tempTestData.sections[i].questions[j].review = -1;

                      if (
                        tempTestData.sections[i].questions[j].answer === "" ||
                        tempTestData.sections[i].questions[j].answer === null ||
                        tempTestData.sections[i].questions[j].answer ===
                          undefined
                      ) {
                        tempTestData.sections[i].questions[j].choosed = -1;
                        tempTestData.sections[i].questions[j].answered = -1;
                        tempTestData.sections[i].questions[j].visited =
                          i === 0 && j === 0 ? "this" : "new";
                        tempTestData.sections[i].questions[j].review = -1;
                        tempTestData.sections[i].questions[j].previsited =
                          i === 0 && j === 0 ? "this" : "new";
                      } else {
                        tempTestData.sections[i].questions[j].visited =
                          "completed";
                        tempTestData.sections[i].questions[j].previsited =
                          "completed";
                        tempTestData.sections[i].questions[j].answered = 0;
                      }

                      answerObject = {
                        ...answerObject,
                        [tempTestData.sections[i].questions[j].id]:
                          tempTestData.sections[i].questions[j].answer,
                      };
                    } else {
                      tempTestData.sections[i].questions[j].review = -1;
                      tempTestData.sections[i].questions[j].choosed = -1;
                      tempTestData.sections[i].questions[j].answered = -1;

                      tempTestData.sections[i].questions[j].visited =
                        i === 0 && j === 0 ? "this" : "new";

                      tempTestData.sections[i].questions[j].previsited =
                        i === 0 && j === 0 ? "this" : "new";

                      answerObject = {
                        ...answerObject,
                        [tempTestData.sections[i].questions[j].id]: "",
                      };
                    }

                    if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
                      let question = tempTestData.sections[i].questions[j];

                      for (let k = 0; k < question.links.length; k++) {
                        let linkRes = await getPreSignedUrl(
                          question.links[k].link, undefined, question.links[k].link?.split(".")?.pop(), "GET"
                        );

                        question.links[k].link = linkRes.url;
                      }
                    }
                  }
                }

                Alert.setAnswers(answerObject);
                Alert.setMcqTestData(tempTestData);
                Alert.updateComingObj(tempTestData);
                questionUpdate(0, 0, tempTestData);
                Alert.updateQuestionContainerSingle(true);
                traverseInitialize();
                Alert.setTestMode(res.data.data.testmode);
                Alert.duration.current = tempTestData.timeleft;

                if (
                  Alert.testData.proctored ===
                    constants.PROCTORING_MODE.TAB_CAM &&
                  Alert.testData.testmode === constants.MODE.TEST_MODE
                ) {
                  Alert.setIsTakeTest(true);
                }

                Alert.navigate("/mcq");
              }
            } catch (err) {
              getCatchBlockDetails(err);
            } finally {
              Alert.setIsLoaded(false);
              Alert.setButtonDisable(false);
            }
          })();
        })
        .catch((error) => {
          getCatchBlockDetails(error);
        })
        .finally(() => {
          Alert.setIsLoaded(false);
          Alert.setButtonDisable(false);
        });
    }
  };

  const fetchVideoData = async (path) => {
    try {
      let url;

      if (process.env.REACT_APP_DEPLOYMENT === "LOCAL") {
        url = { url: process.env.REACT_APP_NODE_API + path };
      } else {
        // const result = await getS3Object(
        //   path,
        //   undefined,
        //   "arraybuffer"
        // );
        const {url: signedUrl} = await getPreSignedUrl(
          path,
          undefined,
          path?.split(".")?.pop(),
          "GET"
        );

        const result= await axiosPublic.default({
          method: "GET",
          url: signedUrl,
          responseType: "arraybuffer",
        })

        // const uint8Array = await streamToUint8Array(result.data);
        const blob = new Blob([result.data], { type: "video/mp4" });

        url = URL.createObjectURL(blob);
      }

      return url;
    } catch (error) {
      console.error("Error fetching Video data:", error);
    }
  };

  const viewTest = () => {
    Alert.setTakeMcqAndDesTest(true);

    if (
      Alert.status === constants.PROGRESS_STATUS.EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.TO_BE_EVALUATED ||
      Alert.status === constants.PROGRESS_STATUS.PARTIAL_EVALUATED
    ) {
      Alert.setMcqAndDesTestAndLpId({
        lpid: Alert.lpId,
        status: Alert.status,
        testid: Alert.testData.testid,
        cellobj: Alert.testData.libtype,
        autoEval: Alert.testData.autoeval,
        testmode: Alert.testData.testmode,
        viewTest: Alert.testData.viewtest,
        libtypeid: Alert.testData.testtype,
        proctored: Alert.testData.proctored,
        configdata: Alert.testData.configdata,
        lpconfigid: Alert.testData.lpconfigid,
        learnerid: getDataFromStorage("learnerid"),
      });

      if (!Alert.hasRendered.current) {
        Alert.hasRendered.current = true;

        Alert.setButtonDisable(true);
        Alert.setIsLoaded(true);
        Alert.setIsTakeTest(false);

        axios
          .post(
            "node/learner/course/test/report",
            JSON.stringify({
              lpid: Alert.lpId,
              lmpid: Alert.testData.lmpid,
              testid: Alert.testData.testid,
              mockuse: Alert.testData.mockuse,
              libtypeid: Alert.testData.libtypeid,
              lpconfigid: Alert.testData.lpconfigid,
              learnerid: getDataFromStorage("learnerid"),
            }),
            getHeaderDetailsForAxios()
          )
          .then((res) => {
            Alert.setButtonDisable(false);
            Alert.hasRendered.current = false;
            Alert.backupTestDataq.current = res.data.data;
            res.data.data.mockuse = Alert.testData.mockuse;
            console.log("Alert.testData.testtype",Alert.testData);
            console.log("res.data.data", res.data.data);
            (async () => {
              try {
                if (res.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
                  Alert.setShowNotify({
                    show: true,
                    title: "Info",
                    msg: res.data.message,
                  });
                } else {
                  
                  if (Alert.testData.testtype === constants.libTypeIds.SQL) {
                     res.data.data.sections[0].questions =
                      res.data.data.sections[0]?.questions.map(
                        ({ actualscore, targetscore, answer, ...rest }, _, arr) => ({
                          ...rest,
                          solution: answer,
                          timeleft: res.data.data.timeleft,
                          duration: res.data.data.duration,
                          commentsdata: res.data.data.commentsdata,
                          // actualscore: arr.reduce(
                          //   (sum, q) => sum + q.actualscore,
                          //   0
                          // ),
                          // targetscore: arr.reduce(
                          //   (sum, q) => sum + q.targetscore,
                          //   0
                          // ),
                          actualscore,
                          targetscore

                        })
                      );
                      
                    Alert.setTestDetail(() => ({
                      ...res.data,
                      currentIndex: 0,
                      data: res.data.data,
                      ...(res.data.data.sections[0]?.questions[0] || {}),
                      totalQn: res.data.data.sections[0]?.questions.length,
                      schema: parseCreateTable(
                        res.data.data.sections[0]?.questions[0].dbSchema
                      ),
                      language: [
                        {
                          value: 1,
                          label: "SQL",
                        },
                      ],
                      selectedLanguage: {
                        value: 1,
                        label: "SQL",
                      },
                    }));

                    Alert.navigate("/sql");
                  } else {
                    tempReport = res.data.data;

                    if (tempReport.videoqn === 1) {
                      handleVideoQuestions(tempReport.sections);
                    }

                  

                    calcStats(tempReport, ["all"]);
                    Alert.setTestDetail({...res.data.data,libtypeid:Alert.testData.testtype});
                    Alert.setTestMode(res.data.data.testmode);
                    Alert.setApiLoaded(true);
                    Alert.backupTestDataq.current = res.data.data;
                    Alert.setDescScores(tempScoresObj);
                    Alert.setBackupTestData(res.data.data);
                    Alert.setMcqTestData(res.data.data);
                    Alert.updateComingObj(res.data.data);
                    Alert.updateQuestionContainerSingle(false);
                    clearInterval(Alert.interval.current);
                    Alert.setTestPageShow(true);

                    for (let i = 0; i < res.data.data.sections.length; i++) {
                      for (
                        let j = 0;
                        j < res.data.data.sections[i].questions.length;
                        j++
                      ) {
                        if (process.env.REACT_APP_DEPLOYMENT === "AWS") {
                          let question = res.data.data.sections[i].questions[j];

                          if (getDataFromStorage("role") === "learner") {
                            question.review = -1;
                          }

                          for (let k = 0; k < question.links.length; k++) {
                            let linkRes = await getPreSignedUrl(
                              question.links[k].link, undefined, question.links[k].link?.split(".")?.pop(), "GET"
                            );

                            question.links[k].link = linkRes.url;
                          }

                          if (tempReport.videoqn === 1) {
                            if (
                              res.data.data.sections[i].questions[j].answer !==
                                "" &&
                              res.data.data.sections[i].questions[j].answer !=
                                null
                            ) {
                              // let videoRes = await fetchVideoData(
                              //   res.data.data.sections[i].questions[j].answer
                              // );

                              // res.data.data.sections[i].questions[j].answer =
                              //   videoRes;
                              Alert.updateComingObj(res.data.data);
                            }
                          }
                        }

                        if (
                          res.data.data.sections.length - 1 === i &&
                          res.data.data.sections[i].questions.length - 1 === j
                        ) {
                          Alert.setIsLoaded(false);

                          if (tempReport.videoqn)
                            Alert.setTestPageShowReload(
                              (prevState) => !prevState
                            );
                        }
                      }
                    }
                    Alert.navigate("/mcq");
                  }
                }
              } catch (err) {
                getCatchBlockDetails(err);
              } finally {
                Alert.setIsLoaded(false);
              }
            })();
          })
          .catch((error) => {
            getCatchBlockDetails(error);
          })
          .finally(() => Alert.setIsLoaded(false));
      }
    }
  };

  return {
    viewTest,
    startTest,
    calcStats,
    questionUpdate,
    handleVideoQuestions,
  };
}
